import {
  AllCountriesDataProps,
  getCountryMappings
} from '@uma/react-commons/dist/index';

/**
- * Checks if the Orders page should be visible for the current country.
- * @returns {Promise<boolean>} - True if the page should be active, false otherwise.
- */
const isOrdersPageActive = async (): Promise<boolean> => {
  try {
    const result = await getCountryMappings(
      AllCountriesDataProps.IsOrdersPageActive
    );

    if (typeof result !== 'boolean') {
      throw new Error(
        `Error from getCountryMappings returned a non-boolean value: ${result}`
      );
    }

    return Boolean(result);
  } catch (error) {
    console.error(
      'Error checking Orders page availability. Defaulting to show the page:',
      error
    );
    return true;
  }
};

export default isOrdersPageActive;
